__webpack_require__.p = "/pt/maragogi/semana-do-consumidor/";